import { Typography } from '@mui/material';
import type React from 'react';
import type { ReactNode } from 'react';

interface TitleProps {
  children: ReactNode;
}

export default function Title({ children }: TitleProps): React.ReactElement {
  return (
    <Typography
      sx={{
        marginBottom: '20px',
      }}
      variant="h6"
    >
      {children}
    </Typography>
  );
}
